import {PROPERTY_TYPE_ALL, isPropertyTypeAll} from './property-types';
import {UNREFINED_KEY, isUnrefined} from './listings';
import {evaluateExperimentAndLog} from '@homeaway/abacus-client-utils';

export function pushEdapEvent(event, eventOptions, edapOptions) {
    window.edap.push((edap) => edap.trigger(event, eventOptions, edapOptions));
}

export function getRefinements({
    propertyType = PROPERTY_TYPE_ALL,
    refinementKey = UNREFINED_KEY,
    position,
    forceAddRefinementKey = false,
}) {
    const eventrefinements = [];
    if (!isPropertyTypeAll(propertyType)) {
        eventrefinements.push(propertyType);
    }
    if (!isUnrefined(refinementKey) || forceAddRefinementKey) {
        eventrefinements.push(
            position
                ? `filter:${refinementKey},position:${position}`
                : `filter:${refinementKey}`
        );
    }

    return eventrefinements.join(',');
}

export function getActionLocation(template) {
    return /multi-destination/.test(template) ? 'mlp' : 'slp';
}

export function getPageType(template) {
    return getActionLocation(template);
}

// TODO: Remove reportSearchSubmit from actions when fast path migration is over
export function reportSearchSubmitFastPath({
    actionLocation,
    edapEventName,
    eventRefinements,
    eventAction,
    eventLbsuuid,
}) {
    pushEdapEvent(edapEventName, {
        action_location: actionLocation,
        event_refinements: eventRefinements,
        event_action: eventAction,
        event_lbsuuid: eventLbsuuid,
    });
}

export function exposeOnGdprConsent(testName) {
    window.cookieconsent = window.cookieconsent || [];

    window.cookieconsent.push((cookieAccess) => {
        const consents = cookieAccess.getConsents();
        if (consents && consents.functional) {
            evaluateExperimentAndLog(testName);
        }
    });
}
